import * as endpoints from './endpoints';

const AiInsightService = { ...endpoints };

export default AiInsightService;
export type { AiInsightMode, AiInsightInput, ConversationMessage } from './endpoints';
